export const decode = base64 => {
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }

  return outputArray;
};



// WEBPACK FOOTER //
// ./app/javascript/mastodon/utils/base64.js